/** SoftR team / region → flag emoji (🌍 when unknown). Shared by productivity + impersonation picker. */
const TEAM_FLAGS: Record<string, string> = {
  "United States": "🇺🇸",
  Berkeley: "🇺🇸",
  India: "🇮🇳",
  Nigeria: "🇳🇬",
  Brazil: "🇧🇷",
  Philippines: "🇵🇭",
  Bangladesh: "🇧🇩",
  Mexico: "🇲🇽",
  Peru: "🇵🇪",
  Rwanda: "🇷🇼",
  Tanzania: "🇹🇿",
  FAMSA: "🌍",
  "South Africa": "🇿🇦",
  "Cape Town": "🇿🇦",
  Uganda: "🇺🇬",
  Vietnam: "🇻🇳",
  Ethiopia: "🇪🇹",
};

export function flagForTeam(team: string | null | undefined): string {
  const t = team?.trim();
  if (!t || t.toLowerCase() === "pilot") return "🌍";
  return TEAM_FLAGS[t] ?? "🌍";
}

export function teamLabel(team: string | null | undefined): string {
  const t = team?.trim();
  if (!t || t.toLowerCase() === "pilot") return "No region";
  return t;
}
